export default {
  mounted() {},
  methods: {
    async getShared(id, type) {
      switch (type) {
        case 'brain':
          return this.getSharedOfBrain(id)
        case 'notebook':
          return this.getSharedOfNotebook(id)
        case 'studio':
          return this.getSharedOfStudio(id)
        default:
          alert('Unexpected params of getShared()')
          break
      }
    },
    async postShare(id, param, type) {
      switch (type) {
        case 'brain':
          return this.postShareOfBrain(id, param)
        case 'notebook':
          return this.postShareOfNotebook(id, param)
        case 'studio':
          return this.postShareOfStudio(id, param)
        default:
          alert('Unexpected params of postShare()')
          break
      }
    },
    async deleteShared(id, email, type) {
      switch (type) {
        case 'brain':
          return this.deleteShareOfBrain(id, email)
        case 'notebook':
          return this.deleteShareOfNotebook(id, email)
        case 'studio':
          return this.deleteShareOfStudio(id, email)
        default:
          alert('Unexpected params of deleteShared()')
          break
      }
    },
    async postPublishV2(id, type) {
      switch (type) {
        case 'brain':
          return this.postPublishOfBrainV2(id)
        case 'notebook':
          return this.postPublishOfNotebookV2(id)
        case 'studio':
          return this.postPublishOfStudioV2(id)
        default:
          alert('Unexpected params of postPublish()')
          break
      }
    },
    async viewer(id, type) {
      switch (type) {
        case 'brain':
          return this.brainsViewer(id)
        case 'studio':
          return this.studiosViewer(id)
        default:
          alert('Unexpected params of viewer()')
          break
      }
    },
  },
}
